module.exports = __webpack_public_path__ + "img/johan-smc.a81c8580.jpg";